module.exports = __webpack_public_path__ + "img/minus_btn.15b49029.png";